const initialState = {
    isPlaceOrders : false,
    placeOrders:{},
    orders:[],
    items:[],
};

export default initialState;
